import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const FearAndGreedLineChart = defineAsyncComponent(() => import('@/js/fear-and-greed-index/FearAndGreedLineChart.vue'));
const FearAndGreedShare = defineAsyncComponent(() => import('@/js/fear-and-greed-index/FearAndGreedShare.vue'));

app.component('FearAndGreedLineChart', FearAndGreedLineChart);
app.component('FearAndGreedShare', FearAndGreedShare);

mountApp();
